import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css'
import { ACCESS_TOKEN } from '@/store/mutation-types'




const defaultRoutePath = '/';
 const setDocumentTitle = function (title) {
    document.title = title
    const ua = navigator.userAgent
    const regex = /\bMicroMessenger\/([\d\.]+)/
    if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
      const i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(function () {
          i.remove()
        }, 9)
      }
      document.body.appendChild(i)
    }
  }
const domTitle = '云加工供应链平台';

router.beforeEach((to,from,next) => {
    NProgress.start()
    to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`))
    if(Vue.ls.get(ACCESS_TOKEN)){
        if (to.path === '/login') {
            next({ path: '/' })
            NProgress.done();
        }else{
            if(store.getters.userInfo.length === 0){
                console.log('请求了数据')
                store.dispatch('GetInfo',{}).then(res =>{
                    const redirect = decodeURIComponent(from.query.redirect || to.path);
                    if(to.path === redirect) {
                        next({ ...to, replace: true })
                    }else{
                        next({ path: redirect })
                    }
                }).catch((error) => {
                    console.log('用户信息获取失败',error)
                })
            }else if(store.getters.routers.length === 0){
                const hasRoles = store.getters.role && store.getters.role.length > 0;
                if(hasRoles){
                    store.dispatch('GenerateRoutes',store.getters.role).then(res => {
                        router.addRoutes(res);
                        const redirect = decodeURIComponent(from.query.redirect || to.path);
                        if(to.path === redirect) {
                            next({ ...to, replace: true })
                        }else{
                            next({ path: redirect })
                        }
                    }).catch((error) => {
                        console.log('路由获取失败',error)
                    })
                }else{
                    next();
                }
            }else{
                next();
            }
        }  
    }else{
        next();
    }
})


router.afterEach(() => {
    NProgress.done()
  })